<span class="rolling-counter" [class.is-negative]="isNegative">
  <span class="sign" *ngIf="isNegative">-</span>
  <span class="digit"
        *ngFor="let d of digits; trackBy: trackDigit"
        [class.snapping]="d.snapping">
    <span class="reel" [style.transform]="digitOffset(d)">
      <span class="cell">0</span>
      <span class="cell">1</span>
      <span class="cell">2</span>
      <span class="cell">3</span>
      <span class="cell">4</span>
      <span class="cell">5</span>
      <span class="cell">6</span>
      <span class="cell">7</span>
      <span class="cell">8</span>
      <span class="cell">9</span>
      <span class="cell">0</span>
      <span class="cell">1</span>
      <span class="cell">2</span>
      <span class="cell">3</span>
      <span class="cell">4</span>
      <span class="cell">5</span>
      <span class="cell">6</span>
      <span class="cell">7</span>
      <span class="cell">8</span>
      <span class="cell">9</span>
    </span>
  </span>
  <ng-container *ngIf="hasFraction">
    <span class="separator">.</span>
    <span class="digit"
          *ngFor="let d of decimalDigits; trackBy: trackDigit"
          [class.snapping]="d.snapping">
      <span class="reel" [style.transform]="digitOffset(d)">
        <span class="cell">0</span>
        <span class="cell">1</span>
        <span class="cell">2</span>
        <span class="cell">3</span>
        <span class="cell">4</span>
        <span class="cell">5</span>
        <span class="cell">6</span>
        <span class="cell">7</span>
        <span class="cell">8</span>
        <span class="cell">9</span>
        <span class="cell">0</span>
        <span class="cell">1</span>
        <span class="cell">2</span>
        <span class="cell">3</span>
        <span class="cell">4</span>
        <span class="cell">5</span>
        <span class="cell">6</span>
        <span class="cell">7</span>
        <span class="cell">8</span>
        <span class="cell">9</span>
      </span>
    </span>
  </ng-container>
  <span class="suffix" *ngIf="suffix">{{ suffix }}</span>
</span>
